import React from 'react'
import PaymentSchedulesList from './PaymentSchedulesList'
import ActivityLog from './ActivityLog'
import ActivityComposer from './ActivityComposer'

export default function CaseDetailPanel({ collectionCase, focusActivity, onActivityFocused }) {
    const caseId = Number(collectionCase.id)
    const tags = collectionCase.driverTags ?? []
    return (
        <div className="cd-panel">
            {tags.length > 0 && (
                <div className="cd-panel-tags">
                    <span className="label">TAGS</span>
                    {tags.map((t, i) => (
                        <span
                            key={t.name || i}
                            className="cd-tag-chip"
                            style={{ background: t.color ? `#${t.color}` : '#6c757d' }}
                        >
                            {t.name}
                        </span>
                    ))}
                </div>
            )}
            <div className="cd-panel-grid two-col">
                <div className="cd-card">
                    <PaymentSchedulesList driverId={collectionCase.driverId} />
                </div>
                <div className="cd-card">
                    <h3>Activity</h3>
                    <ActivityComposer
                        caseId={caseId}
                        focusOnMount={focusActivity}
                        onFocused={onActivityFocused}
                    />
                    <div className="cd-activity-divider" />
                    <ActivityLog caseId={caseId} />
                </div>
            </div>
        </div>
    )
}
